module.exports = __webpack_public_path__ + "static/media/SWITZERLAND.fda09c52.svg";